import { useTranslation } from "react-i18next"
import { memo } from "react"
import Button from "./button"
import { ReactComponent as RefreshIcon } from "assets/icons/refresh.svg"

interface ProcessingButtonProps {
    design: string
}

const ProcessingButton: React.FC<ProcessingButtonProps> = ({ design }) => {

    const { t } = useTranslation()

    return <Button wideOnMobile design={design} disabled><RefreshIcon className="animate-spin" /><span>{t(`buttonProcessing`)}...</span></Button>
}

export default memo(ProcessingButton)

